import { Component, Inject } from '@angular/core'
import { BasePanelComponent, LayoutContainer } from '@helios/panel-base'
import { RootState, selectFocusedAccounts } from '@helios/state-management'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { Store } from '@ngrx/store'
import { ToastService } from '@northfork/ng-basics'
import { ComponentContainer } from 'golden-layout'
import { Subject, Subscription } from 'rxjs'
import {
  debounceTime,
  distinctUntilChanged,
  takeUntil,
  tap,
} from 'rxjs/operators'
import { AccountDetailsKey } from '../panel-key'
import { AccountDetailsService } from './services/account-details.service'

@Component({
  selector: 'hs-account-details',
  templateUrl: './account-details-panel.component.html',
  styleUrls: ['./account-details-panel.component.scss'],
})
export class AccountDetailsPanelComponent extends BasePanelComponent {
  panelKey = AccountDetailsKey
  constructor(
    @Inject(LayoutContainer) container: ComponentContainer,
    readonly store: Store<RootState>,
    public accountDetailsService: AccountDetailsService,
    private readonly modalService: NgbModal,
    public toastService: ToastService,
  ) {
    super(container)
  }
  private readonly destroySubject = new Subject<void>()
  showSleeveDetails = true
  showAggregateDetails = true
  sessionSub?: Subscription
  accountId?: number
  selectedAccounts: number[] = []

  ngAfterViewInit(): void {
    this.sessionSub = this.store
      .select(selectFocusedAccounts)
      .pipe(
        debounceTime(500),
        takeUntil(this.destroySubject),
        distinctUntilChanged(),
        tap(accounts => {
          this.setAccounts(accounts)
        }),
      )
      .subscribe()
  }

  setAccounts(accounts: number[]) {
    if (accounts.length > 0) {
      this.selectedAccounts = accounts
      if (accounts.length == 1) {
        this.showSleeveDetails = true
        this.showAggregateDetails = true
        this.accountId = accounts[0]
      } else {
        this.accountId = undefined
      }
    }
  }
  hideSleeveDetails(show: boolean) {
    this.showSleeveDetails = show
  }

  hideAggregateDetails(show: boolean) {
    this.showAggregateDetails = show
  }

  ngOnDestroy(): void {
    if (this.sessionSub) {
      this.sessionSub.unsubscribe()
    }
  }
}
